import React from 'react';
import { NavLink } from 'react-router-dom';

const Sisteme = () => {
  return (
    <div className="sisteme-page">
      <div className="page-navigation-header">
        <div className="nav-header-content">
          <NavLink to="/dashboard" className="back-to-dashboard">
            ← Înapoi la Dashboard
          </NavLink>
          <div className="quick-nav">
            <NavLink to="/patients" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
              Pacienți
            </NavLink>
            <NavLink to="/appointments" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
              Programări
            </NavLink>
            <NavLink to="/doctors" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
              Doctori
            </NavLink>
          </div>
        </div>
      </div>

      <div className="page-header">
        <h1>Sisteme și Aplicații</h1>
        <p>Accesați toate sistemele și aplicațiile disponibile</p>
      </div>

      {/* Internal Applications Section */}
      <div className="applications-section">
        <h3 className="section-title">Sisteme și Aplicații Interne</h3>
        <div className="app-grid">
          <a href="https://sps.evoomedical.ro/login" className="app-item app-pink">
            <div className="app-icon">📅</div>
            <div className="app-details">
              <div className="app-name">SPS</div>
              <div className="app-access">Acces</div>
            </div>
          </a>
          <NavLink to="/patients" className="app-item app-blue">
            <div className="app-icon">👥</div>
            <div className="app-details">
              <div className="app-name">Gestiune Pacienți</div>
              <div className="app-access">Acces</div>
            </div>
          </NavLink>
          <NavLink to="/doctors" className="app-item app-green">
            <div className="app-icon">👨‍⚕️</div>
            <div className="app-details">
              <div className="app-name">Portal Doctori</div>
              <div className="app-access">Acces</div>
            </div>
          </NavLink>
          <NavLink to="/reports" className="app-item app-orange">
            <div className="app-icon">📊</div>
            <div className="app-details">
              <div className="app-name">Rapoarte Medicale</div>
              <div className="app-access">Acces</div>
            </div>
          </NavLink>
          <NavLink to="/staff" className="app-item app-purple">
            <div className="app-icon">👔</div>
            <div className="app-details">
              <div className="app-name">Personal Medical</div>
              <div className="app-access">Acces</div>
            </div>
          </NavLink>
          <NavLink to="/settings" className="app-item app-teal">
            <div className="app-icon">⚙️</div>
            <div className="app-details">
              <div className="app-name">Setări Sistem</div>
              <div className="app-access">Acces</div>
            </div>
          </NavLink>
        </div>
      </div>

      {/* External Applications Section */}
      <div className="applications-section">
        <h3 className="section-title">Aplicații Externe</h3>
        <div className="app-grid">
          <NavLink to="/blob-storage" className="app-item app-teal">
            <div className="app-icon">🔗</div>
            <div className="app-details">
              <div className="app-name">Azure Blob Storage</div>
              <div className="app-access">Încărcare fișiere</div>
            </div>
          </NavLink>
          <a href="https://example.com/app2" className="app-item app-purple">
            <div className="app-icon">💻</div>
            <div className="app-details">
              <div className="app-name">Aplicație Externă 2</div>
              <div className="app-access">Acces</div>
            </div>
          </a>
          <a href="https://example.com/app3" className="app-item app-red">
            <div className="app-icon">🌐</div>
            <div className="app-details">
              <div className="app-name">Aplicație Externă 3</div>
              <div className="app-access">Acces</div>
            </div>
          </a>
          <a href="https://example.com/app4" className="app-item app-yellow">
            <div className="app-icon">📱</div>
            <div className="app-details">
              <div className="app-name">Aplicație Externă 4</div>
              <div className="app-access">Acces</div>
            </div>
          </a>
        </div>
      </div>

      <style jsx>{`
        .sisteme-page {
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem;
        }

        .page-navigation-header {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          margin-bottom: 2rem;
          padding: 1rem;
        }

        .nav-header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .back-to-dashboard {
          color: #667eea;
          text-decoration: none;
          font-weight: 500;
          padding: 0.5rem 1rem;
          border-radius: 4px;
          transition: background 0.3s;
        }

        .back-to-dashboard:hover {
          background: #f8f9fa;
        }

        .quick-nav {
          display: flex;
          gap: 1rem;
        }

        .quick-nav-link {
          padding: 0.5rem 1rem;
          color: #666;
          text-decoration: none;
          border-radius: 4px;
          font-weight: 500;
          transition: all 0.3s;
        }

        .quick-nav-link:hover, .quick-nav-link.active {
          background: #667eea;
          color: white;
        }

        .page-header {
          margin-bottom: 2rem;
        }

        .page-header h1 {
          color: #333;
          margin-bottom: 0.5rem;
        }

        .page-header p {
          color: #666;
        }

        /* Applications Section */
        .applications-section {
          background: white;
          padding: 2rem;
          border-radius: 12px;
          margin-bottom: 2rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }

        .section-title {
          font-size: 1.3rem;
          color: #333;
          margin-bottom: 1.5rem;
          font-weight: 600;
        }

        .app-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 1.5rem;
        }

        .app-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.5rem;
          background: white;
          border-radius: 12px;
          text-decoration: none;
          transition: all 0.3s;
          border: 2px solid #f0f0f0;
        }

        .app-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .app-icon {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: white;
          flex-shrink: 0;
        }

        .app-pink .app-icon {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }

        .app-blue .app-icon {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
        }

        .app-green .app-icon {
          background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
        }

        .app-orange .app-icon {
          background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
        }

        .app-teal .app-icon {
          background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
        }

        .app-purple .app-icon {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        .app-red .app-icon {
          background: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
        }

        .app-yellow .app-icon {
          background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
        }

        .app-details {
          flex: 1;
        }

        .app-name {
          font-size: 1rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.25rem;
        }

        .app-access {
          font-size: 0.85rem;
          color: #999;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .sisteme-page {
            padding: 1rem;
          }

          .page-navigation-header {
            padding: 0.75rem;
          }

          .nav-header-content {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
          }

          .quick-nav {
            width: 100%;
            justify-content: flex-start;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }

          .page-header {
            text-align: center;
          }

          .page-header h1 {
            font-size: 1.5rem;
          }

          .page-header p {
            font-size: 0.9rem;
          }

          .applications-section {
            padding: 1.5rem;
          }

          .section-title {
            font-size: 1.1rem;
          }

          .app-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .app-item {
            padding: 1.25rem;
            min-height: 80px;
          }

          .app-icon {
            width: 45px;
            height: 45px;
            font-size: 1.25rem;
          }

          .app-name {
            font-size: 0.95rem;
          }

          .app-access {
            font-size: 0.8rem;
          }
        }

        @media (max-width: 480px) {
          .sisteme-page {
            padding: 0.5rem;
          }

          .page-navigation-header {
            padding: 0.5rem;
          }

          .back-to-dashboard {
            font-size: 0.9rem;
            padding: 0.4rem 0.8rem;
          }

          .quick-nav-link {
            font-size: 0.85rem;
            padding: 0.4rem 0.8rem;
          }

          .page-header h1 {
            font-size: 1.3rem;
          }

          .applications-section {
            padding: 1rem;
            margin-bottom: 1rem;
          }

          .app-item {
            padding: 1rem;
            gap: 0.75rem;
          }

          .app-icon {
            width: 40px;
            height: 40px;
            font-size: 1.1rem;
          }

          .app-name {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Sisteme;
